import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class VilleService {

    constructor(){
        this.adresse = new AdresseIP()
    }

    getAuthHeaders() {
        const storedToken = localStorage.getItem('accessToken');
        if (!storedToken) return {};

        try {
            const token = JSON.parse(storedToken);
            return token ? { Authorization: `Bearer ${token}` } : {};
        } catch (error) {
            return { Authorization: `Bearer ${storedToken}` };
        }
    }
    
    /*getAll() {
        
        return axios.get('http://192.168.43.106:8083/service/api/hebergement-cenou/campus-faso/critere')
                    .then(res => res.data);
    }
    create(newCritere) {
        const url = 'http://192.168.43.106:8083/service/api/hebergement-cenou/campus-faso/critere'
        return axios.post(url,newCritere)
                    .then(res => res.data);
    }
    update(idCritere ,newCritere) {
        const url = 'http://192.168.43.106:8083/service/api/hebergement-cenou/campus-faso/critere/'
        return axios.put(url+idCritere, newCritere)
                    .then(res => res.data);
    }
    delete(idCritere) {
        const url = 'http://192.168.43.106:8083/service/api/hebergement-cenou/campus-faso/critere/'
        return axios.patch(url+idCritere)
                    .then(res => res.data)
    }*/

    getAll() {
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/ville', {
            headers: this.getAuthHeaders()
        }).then(res => res.data);
    }
    
    create(newVille) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/ville'
        return axios.post(url,newVille, {
            headers: this.getAuthHeaders()
        }).then(res => res.data);
    }
    update(idVille ,newVille) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/ville/'
        return axios.put(url+idVille, newVille)
                    .then(res => res.data);
    }
    delete(idVille) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/ville/'
        return axios.patch(url+idVille, {
            headers: this.getAuthHeaders()
        }).then(res => res.data)
    }

    getVilleDirection(idDirection){
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/ville/direction?idDirection='+idDirection, {
            headers: this.getAuthHeaders()
        }).then(res => res.data);
    
    }

}